<template>
  <v-container>
    <ViewsContainer
      :moduleName="moduleName"
      :listViewComponent="Table"
      :filterComponent="Filter"
      :data="data"
      :config="'@/components/modules/leads/leads.config'"
      :onCreate="create"
      :onUpdate="update"
      :onDelete="remove"
      :exportCsv="exportCsv"
      :rowActionHandlers="rowActionHandlers"
      :show_toolbar="true"
      :show_pagination="true"
      :title="{singular:'Prospecto', plural:'Prospectos'}"
      :key="moduleName"
    />
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useLeadsStore } from '@/store/leads';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/leads/leads.config';
import { useSendFileDialogStore } from '@/store/sendFileDialog';
import { useSendersStore } from '@/store/senders';
import { CARD_FIELDS, DEFAULT_CARD_ORDER } from '@/components/modules/sales/sales.config';
import { useDisplay } from 'vuetify';

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

import Table from '@/components/views/TableView.vue';
import MobileCardsView from '@/components/views/MobileCardsView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue';

const moduleName = 'Leads';
const preferencesStore = usePreferencesStore();
const leadsStore = useLeadsStore();
const sendFileDialogStore = useSendFileDialogStore();
const sendersStore = useSendersStore();

const {
  create,
  update,
  remove,
  exportCsv
} = useModuleLayoutFetcher(
  moduleName,
  (params) => leadsStore.fetchLeads(params),
  {
    create: leadsStore.createLead,
    update: (data) => leadsStore.updateLead(data.id, data),
    remove: leadsStore.deleteLead,
    exportCsv: leadsStore.exportCSV
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  // Registra los headers y defaults para ESTE módulo:
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const convertLeadToClient = (item:any) => {
  
};

const rowActionHandlers = {
  convertLeadToClient
};

const data = computed(() => leadsStore.leads);
</script>
